import { api } from '@kolab/dms-base/api'
import type {
  CreateLicenseProductRequest,
  LicenseProduct,
  PageableQuery,
  PaginatedResponse,
  UpdateLicenseProductRequest,
} from './types'

const BASE = '/v1/license-products'

export async function listLicenseProducts(params?: PageableQuery) {
  return api.get<PaginatedResponse<LicenseProduct>>(BASE, { params, _suppressErrorToast: true }).then((r) => r.data)
}

export async function getLicenseProduct(id: string) {
  return api.get<LicenseProduct>(`${BASE}/${id}`).then((r) => r.data)
}

export async function createLicenseProduct(payload: CreateLicenseProductRequest) {
  return api.post<LicenseProduct>(BASE, payload).then((r) => r.data)
}

export async function updateLicenseProduct(id: string, payload: UpdateLicenseProductRequest) {
  return api.put<LicenseProduct>(`${BASE}/${id}`, payload).then((r) => r.data)
}
